import React from 'react';
import DefaultLayout3 from '../../components/layout/DefaultLayout3';
import AsyncMsrTemplateRequests from './msrtemplaterequests/async';

export default [
  <DefaultLayout3
    exact
    key="a"
    path="/epf/msr-template-requests/:requestId"
    component={AsyncMsrTemplateRequests}
  />,
];
